const FileViewer = {
  props: [
    {
      name: 'title',
      default: '',
      type: 'string',
      desc: '文件展示名称， 不指定将从url中提取'
    },
    {
      name: 'name',
      default: '',
      type: 'string',
      desc: '文件下载名称， 不指定将从url中提取'
    },
    {
      name: 'url',
      default: '',
      type: 'string',
      desc: '文件路径'
    }
  ]
}

export default [
  {
    name: 'FileViewer API',
    content: FileViewer
  }
]
